<template>
<div>
    <v-content-layout>
        <template #header>
            <el-input size="medium" prefix-icon="el-icon-search" placeholder="Search" v-model="search" clearable></el-input>
        </template>
        <template #body>
            <e-table :data="items" :total="items.length" :headers="headers" :search="search" :height="window.height - 250" :loading="loading">
                <template #actions="{scope}">
                    <el-dropdown size="mini" v-if=" scope.row.status === 2" trigger="click" split-button type="primary" @click="$downloadFile(scope.row.fileName, scope.row.fileLink)">
                        Download
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item icon="el-icon-view" @click.native="handlePDFPreview(scope.row)">Prewiew PDF</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <span v-else>-</span>
                </template>
            </e-table>
        </template>
    </v-content-layout>
    <PDFPreview ref="pdfPreviewDialog" />
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../../store/types';

import PDFPreview from './PDFPreview';
export default {
    components: {
        PDFPreview
    },
    data: () => ({
        search: ''
    }),
    computed: {
        ...mapGetters({
            headers: 'pdfmanipulator/getHeaders',
            items: 'pdfmanipulator/getItems',
            loading: 'pdfmanipulator/getLoading'
        })
    },
    created() {
        this.loadPdfLogs();
    },
    methods: {
        ...mapActions({
            loadPdfLogs: `pdfmanipulator/${type.PDF_GET_LOGS}`
        }),
        handlePDFPreview(row) {
            this.$refs['pdfPreviewDialog'].handlePDF(row.fileLink);
        },
    }
}
</script>
